import React from 'react';
import {FeaturesList, Grid2Columns, Item, SectionHeader} from '../utils/Styled';
import {Trans} from 'gatsby-plugin-react-i18next';
import {MenuItemIcon} from '../utils/MenuItemIcon';
import {InternalPageLink} from 'components/links/Pages';
import {AnchorLink} from 'components/AnchorLink';
import {MenuLink, Props} from '../utils/types';
import {mainProducts, physicalPayments, advantages} from '../constants/products';

export const Products: React.FC<Props> = ({itemClick}) => {
  const renderItem = (item: MenuLink, index: number) => (
    <Item key={item.slug + '-' + index}>
      <MenuItemIcon name={item.icon} />
      {item.slug ? (
        <InternalPageLink slug={item.slug} activeClassName="active" onClick={itemClick}>
          {item.title}
        </InternalPageLink>
      ) : item.to ? (
        <AnchorLink href={item.to} target="_blank">
          {item.title}
        </AnchorLink>
      ) : (
        item.title
      )}
    </Item>
  );

  return (
    <Grid2Columns columnWidth="250px">
      <div>
        <SectionHeader marginTop="0">
          <Trans>Omnichannel payments</Trans>
        </SectionHeader>
        <FeaturesList>{mainProducts.map((item, index) => renderItem(item, index))}</FeaturesList>
      </div>
      <div>
        <SectionHeader marginTop="0">
          <Trans>Physical payments</Trans>
        </SectionHeader>
        <FeaturesList>
          {physicalPayments.map((item, index) => renderItem(item, index))}
        </FeaturesList>

        <SectionHeader marginTop="24px">
          <Trans>Benefits</Trans>
        </SectionHeader>
        <FeaturesList>{advantages.map((item, index) => renderItem(item, index))}</FeaturesList>
      </div>
    </Grid2Columns>
  );
};
